(function ($) {
  "use strict";

  var GIFT_PROPERTY = "_gift_tie";
  var syncing = false;

  function getConfig() {
    var giftTie = window.wpbingo && wpbingo.settings && wpbingo.settings.giftTie;
    return giftTie && giftTie.enabled && giftTie.variantId ? giftTie : null;
  }

  function getEligibleTotal(cart, variantId) {
    var total = 0;
    $.each(cart.items, function (_, item) {
      if (item.variant_id === variantId) {
        return;
      }
      if (item.properties && item.properties[GIFT_PROPERTY]) {
        return;
      }
      total += item.original_line_price;
    });
    return total;
  }

  function findGiftLine(cart, variantId, markedOnly) {
    var found = null;
    $.each(cart.items, function (index, item) {
      if (item.variant_id !== variantId) {
        return;
      }
      if (markedOnly && (!item.properties || !item.properties[GIFT_PROPERTY])) {
        return;
      }
      found = { item: item, line: index + 1 };
      return false;
    });
    return found;
  }

  function updateGiftTieBar(cart) {
    var config = getConfig();
    if (!config || !$("[data-gift-tie-bar]").length) {
      return;
    }

    var threshold = config.thresholdCents;
    var eligible = getEligibleTotal(cart, config.variantId);
    var $bar = $("[data-gift-tie-bar]");

    if (!cart.item_count) {
      $bar.addClass("hidden");
      return;
    }

    $bar.removeClass("hidden");

    if (eligible >= threshold && threshold > 0) {
      $bar.addClass("full");
      $bar.find(".title-shipping").removeClass("hide");
      $bar.find(".title-spend").addClass("hide");
      $bar.find(".shipping-progress").css("width", "100%").addClass("fire-done");
      return;
    }

    $bar.removeClass("full");
    $bar.find(".title-shipping").addClass("hide");
    $bar.find(".title-spend").removeClass("hide");

    var remaining = threshold - eligible;
    var spend = wpbingo.Currency.formatMoney(
      remaining > 0 ? remaining : 0,
      wpbingo.strings.moneyFormat
    );
    $bar.find(".title-spend .spend").html(spend);

    var percent = threshold > 0 ? (eligible / threshold) * 100 : 0;
    $bar.find(".shipping-progress").css("width", percent + "%").removeClass("fire-done");
  }

  function fetchCart(callback) {
    $.getJSON("/cart.js", callback);
  }

  function addGift(variantId, callback) {
    syncing = true;
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: variantId,
        quantity: 1,
        properties: { _gift_tie: "1" },
      },
      success: function () {
        fetchCart(function (cart) {
          syncing = false;
          callback(cart);
        });
      },
      error: function () {
        syncing = false;
        fetchCart(callback);
      },
    });
  }

  function removeGift(line, callback) {
    syncing = true;
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: { line: line, quantity: 0 },
      success: function (cart) {
        syncing = false;
        callback(cart);
      },
      error: function () {
        syncing = false;
        fetchCart(callback);
      },
    });
  }

  function finishSync(cart, callback) {
    if (typeof callback === "function") {
      callback(cart);
    }
    updateGiftTieBar(cart);
  }

  function syncGiftTie(cart, callback) {
    var config = getConfig();
    if (!config || syncing) {
      finishSync(cart, callback);
      return;
    }

    var threshold = config.thresholdCents;
    var variantId = config.variantId;
    var eligible = getEligibleTotal(cart, variantId);
    var markedGift = findGiftLine(cart, variantId, true);
    var anyGiftVariant = findGiftLine(cart, variantId, false);

    if (eligible >= threshold) {
      if (!markedGift && !anyGiftVariant) {
        addGift(variantId, function (updatedCart) {
          finishSync(updatedCart, callback);
        });
        return;
      }
      finishSync(cart, callback);
      return;
    }

    if (markedGift) {
      removeGift(markedGift.line, function (updatedCart) {
        finishSync(updatedCart, callback);
      });
      return;
    }

    finishSync(cart, callback);
  }

  function patchGetCart() {
    if (!window.ShopifyAPI || ShopifyAPI.__giftTiePatched) {
      return;
    }

    var originalGetCart = ShopifyAPI.getCart;
    ShopifyAPI.getCart = function (callback, added) {
      originalGetCart(function (cart, addedFlag) {
        syncGiftTie(cart, function (updatedCart) {
          if (typeof callback === "function") {
            callback(updatedCart, addedFlag);
          }
        });
      }, added);
    };
    ShopifyAPI.__giftTiePatched = true;
  }

  $(function () {
    if (!getConfig()) {
      return;
    }
    patchGetCart();
    fetchCart(function (cart) {
      updateGiftTieBar(cart);
    });
  });
})(jQuery);
